import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { cargar, seguimiento } from "../carga";

export const fetchEquipo = createAsyncThunk("Equipo/fetchEquipo", () => cargar('equipo'));

export const fetchProfesor = createAsyncThunk("Equipo/fetchProfesor", id => cargar(`equipo/${id}`));

export const EquipoSlice = createSlice({
  name: "equipo",
  initialState: {
    Equipo: [],
    loading: false,
    error: null,
    profesor: {},
  },
  reducers: {},
  extraReducers: builder => {
    seguimiento(builder, fetchEquipo, 'Equipo');
    seguimiento(builder, fetchProfesor, 'profesor');
  },
});

export const selector = (state) => state.equipo;

export default EquipoSlice.reducer;
